import { useSnackbar } from '@/hooks/useSnackbar';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { signIn } from 'next-auth/react';
import { registrarEvento } from '@/services/googleAnalytics';

export interface LogarData {
  email: string;
  senha: string;
}

export const loginValidationSchema = Yup.object().shape({
  email: Yup.string().email('Email inválido').required('O email é obrigatório'),
  senha: Yup.string().required('A senha é obrigatório'),
});

function useLogarScreenHook() {
  const { mostrarSnackbar } = useSnackbar();

  const [esconderTexto, setEsconderTexto] = useState(true);
  const [carregando, setCarregando] = useState(false);
  // const [carregandoLoginApple, setCarregandoLoginApple] = useState(false);
  // const [carregandoLoginFacebook, setCarregandoLoginFacebook] = useState(false);

  const {
    setFocus,
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<LogarData>({
    resolver: yupResolver(loginValidationSchema),
    mode: 'onChange',
  });

  async function realizarLogin(formLogar: LogarData) {
    try {
      registrarEvento('login_email', {});
      setCarregando(true);
      const response = await signIn('email-password', {
        redirect: false,
        email: formLogar.email,
        password: formLogar.senha,
      });

      if (response?.status !== 200) {
        throw new Error(response?.error ?? 'Ocorreu um erro ao logar');
      }

      return true;
    } catch (error: unknown) {
      if (error instanceof Error) {
        mostrarSnackbar({
          color: 'error',
          highContrast: true,
          mensagem: error.message ?? '',
          size: 1,
          variant: 'solid',
        });
      }

      return false;
    } finally {
      setCarregando(false);
    }
  }

  return {
    setFocus,
    register,
    handleSubmit,
    errors,
    isValid,
    esconderTexto,
    setEsconderTexto,
    realizarLogin,
    carregando,
  };
}

export type useLogarScreenHookType = ReturnType<typeof useLogarScreenHook>;

export default useLogarScreenHook;
